import { useState } from "react";
import ModalElement from "../../../Common/ModalElement"
import { csvUrls } from "../../../constants";
import DropZone from "../../ImportData/components/DropZone";
import FooterSection from "../../ImportData/components/FooterSection";
import ButtonElement from "../../../Common/ButtonElement";

const GpsMapping = ({ show, hideModal, successAction }) => {
    const [errorFileds, setErrorFileds] = useState({});
    const [mappings, setMappings] = useState([]);

    const setError = (errResponse) => {
        let errFields = [];
        let mappingData = [];
        if(errResponse?.status == 400) {
            mappingData = errResponse?.data?.errors || [];
        }
        errFields = errResponse?.data?.errors || {};
        setMappings(mappingData);
        setErrorFileds(errFields);
    }

    return <ModalElement size="lg" show={show} title={"GPS Mapping"} onHide={hideModal}>
        <div className="add-inventory">
            {mappings?.length > 0 ? <div>
                <div className="d-flex justify-content-end">
                    <ButtonElement text={"Upload"} cssClass="small-radius mb-1" onClick={() => setError(null)} variant="btn-outline-primary" />
                </div>
                <table className="table table-sm table-bordered mb-0" style={{ backgroundColor: "#f9f9f9"}}>
                        <thead className="table-light">
                            <tr>
                                {["Sl No.", "GPS IMEI", "SIM IMEI", "Status"].map((item, index) => <th scope="col" className="text-start" key={index}>{item}</th>)}
                            </tr>
                        </thead>
                        <tbody id="inventory-body">
                            {mappings?.map((item, index) => <tr key={index}>
                                <td className="text-start">{index + 1}</td>
                                <td className="text-start">{item?.y_gps_imei ?? ""}</td>
                                <td className="text-start">{item?.y_sim_number ?? ""}</td>
                                <td className="text-start">{item?.y_status ?? ""}</td>
                            </tr>)}
                        </tbody>
                    </table>
            </div> : <div className="uploader-section rounded py-2 px-2" style={{ backgroundColor: "#dbdbdb6b" }}>
                <DropZone key={errorFileds?.length ?? 0} url={csvUrls.mapping} successCB={() => {
                    successAction();
                    hideModal();
                }} fileName={"mapping"} setError={(error) => setError(error)} />
                <FooterSection errorFileds={errorFileds} />
            </div>}
        </div>
    </ModalElement>
}

export default GpsMapping;